import { defaultDisciplineId } from 'constants/disciplines';
export const getDefaultDiscipline = (disciplines) => {
  if (!disciplines || !disciplines.length) return null;
  return disciplines.find((d) => d.id === defaultDisciplineId);
};
